import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ValaszDto extends IdentifiableDto {
	constructor() {
		super();
        this.betujel = null;
        this.helyes = null;
        this.name = null;
    }

	setup(props) {
		super.setup(props);
        this.betujel = props.betujel;
        this.helyes = props.helyes;
        this.name = props.name;
		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}

export default ValaszDto;
